import { object, string as yupString } from 'yup'

export const CANCEL_PREMIUM_REASONS = [
  { value: "I'm not using the credits to their full potential" },
  { value: "I don't need that much promotion for my music" },
  { value: "I'm experiencing difficulties using the service" },
  { value: "I'm not satisfied with the results of campaigns" },
  { value: 'The cost is too high for me' },
  { value: 'Other (please specify)' },
]

export const cancelPremiumFormSchema = object().shape({
  reason: yupString().required(),
  reasonDetails: yupString().when('reason', (reason, schema) => {
    if (
      reason.includes(
        CANCEL_PREMIUM_REASONS[CANCEL_PREMIUM_REASONS.length - 1].value,
      )
    ) {
      return schema.required('Must enter a reason for cancellation')
    }
    return schema
  }),
})
